import React, { useState, useEffect } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { Controller, useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import OButton from 'components/reusable/OButton'
import { useTranslation } from 'react-i18next'
import OInputField from 'components/reusable/OInputField'
import formValidation from 'utils/formValidation'
import OTextArea from 'components/reusable/OTextArea'
import ErrorMessage from 'components/ErrorMessage'
import Permission from './Permission'
import OMultiSelect from 'components/reusable/OMultiSelect'
import {
  DEFAULT_ALLOWED_UNIT_STATUSES,
  multiValueToStatuses,
  statusesToMultiValue,
  UNIT_PROPOSAL_STATUS_OPTIONS,
} from './unitProposalStatuses'

// import _ from 'lodash'
const { startCase, capitalize } = require('lodash')

const SubEdit = ({ setEditShowModal, allSubAdmin, item }) => {
  const { t } = useTranslation()
  const {
    register,
    handleSubmit,
    getValues,
    control,
    watch,
    setValue,
    clearErrors,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      mobile: item?.mobile,
      email: item?.email,
      address: item?.address,
      firstName: item?.firstName,
      lastName: item?.lastName,
      permission: item?.permission,
      password: item?.password,
      canCreateUnitProposal: item?.canCreateUnitProposal !== false,
      allowedUnitProposalStatuses: statusesToMultiValue(
        Array.isArray(item?.allowedUnitProposalStatus) &&
          item?.allowedUnitProposalStatus?.length
          ? item.allowedUnitProposalStatus
          : DEFAULT_ALLOWED_UNIT_STATUSES
      )
    }
  })

  const canCreateProposal = watch('canCreateUnitProposal')
  const canCreateReg = register('canCreateUnitProposal')

  const notification = useToastContext()
  const [permissionJson, setPermissionJson] = useState(Permission)
  const [isDisable, setIsDisable] = useState(true)
  const onChange = event => {
    setIsDisable(false)
    setPermissionJson(current =>
      current.map(obj => {
        console.log(obj.manager, event.target.name)
        if (obj.manager === event.target.name) {
          if (event.target.id === 'add') {
            return {
              ...obj,
              [event.target.id]: event.target.checked,
              view: event.target.checked
            }
          }
          if (event.target.id === 'import') {
            return {
              ...obj,
              [event.target.id]: event.target.checked,
              import: event.target.checked
            }
          }
          if (event.target.id === 'delete' && event.target.checked) {
            return {
              ...obj,
              [event.target.id]: event.target.checked,
              view: event.target.checked
            }
          }
          return { ...obj, [event.target.id]: event.target.checked }
        }
        return obj
      })
    )
  }
  const checkAll = event => {
    setIsDisable(false)
    setPermissionJson(current =>
      current.map(obj => {
        if (obj.manager === event.target.name) {
          return {
            ...obj,
            add: event.target.checked,
            import: event.target.checked,
            view: event.target.checked,
            delete: event.target.checked
          }
        }
        return obj
      })
    )
  }
  const onSubmit = async data => {
    try {
      const path = apiPath.editSubAdmin + '/' + item._id
      const myObj = {
        manager: 'dashboard',
        add: true,
        view: true,
        delete: true
      }
      const permission = JSON.stringify([myObj, ...permissionJson])
      const {
        allowedUnitProposalStatuses,
        ...sendFields
      } = data
      const sendData = {
        ...sendFields,
        permission,
        allowedUnitProposalStatus: sendFields.canCreateUnitProposal
          ? multiValueToStatuses(allowedUnitProposalStatuses ?? [])
          : []
      }
      const result = await apiPut(path, sendData)
      if (result?.data?.success) {
        allSubAdmin()
        setEditShowModal(false)
        notification.success(result.data.message)
      } else {
        notification.error(result.data.message)
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }
  useEffect(() => {
    const permissionData = getValues('permission')
    if (permissionData[0]?.manager === 'dashboard') {
      permissionData.shift()
    }
    setPermissionJson(permissionData)
  }, [])

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative my-6  w-full max-w-[1150px] mx-auto'>
          <div className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>
                  {t('SUB_ADMIN_EDIT_SUB_ADMIN')}
                </h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setEditShowModal(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
                  <div className='px-2'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='firstName'
                      inputLabel={
                        <>
                          {t('FIRST_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      autoFocus
                      maxLength={15}
                      register={register(
                        'firstName',
                        formValidation.subFirstName
                      )}
                      errors={errors}
                    />
                  </div>
                  <div className='px-2'>
                    <OInputField
                      wrapperClassName='relative z-0   w-full group'
                      name='lastName'
                      inputLabel={
                        <>
                          {t('O_LAST_NAME')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='text'
                      maxLength={15}
                      register={register(
                        'lastName',
                        formValidation.subLastName
                      )}
                      errors={errors}
                    />
                  </div>
                  <div className='px-2'>
                    <OTextArea
                      wrapperClassName='relative z-0 mb-6 w-full group'
                      name='address'
                      inputLabel={
                        <>
                          {t('SUB_ADMIN_ADDRESS')}
                          <span className='text-red-500'>*</span>
                        </>
                      }
                      type='textarea'
                      register={register('address', formValidation.address)}
                      errors={errors}
                    />
                  </div>
                  <div className='px-2 w-full col-span-full md:col-span-2 lg:col-span-4'>
                    <label className='flex items-center gap-2 text-sm text-gray-900 cursor-pointer'>
                      <input
                        type='checkbox'
                        className='rounded border-gray-300'
                        {...canCreateReg}
                        onChange={(e) => {
                          canCreateReg.onChange(e)
                          setIsDisable(false)
                          if (!e.target.checked) {
                            setValue('allowedUnitProposalStatuses', [], {
                              shouldDirty: true,
                            })
                            clearErrors('allowedUnitProposalStatuses')
                          }
                        }}
                      />
                      <span>
                        {t('CAN_CREATE_UNIT_PROPOSAL', 'Can create unit proposals')}
                      </span>
                    </label>
                  </div>
                </div>
                {canCreateProposal ? (
                  <div className='px-6 pb-4 relative z-[60] isolate'>
                    <label className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'>
                      {t(
                        'ALLOWED_UNIT_PROPOSAL_STATUSES',
                        'Allowed unit proposal statuses'
                      )}
                    </label>
                    <Controller
                      control={control}
                      name='allowedUnitProposalStatuses'
                      rules={{
                        validate: (v, formValues) => {
                          if (!formValues.canCreateUnitProposal) return true
                          if (Array.isArray(v) && v.length > 0) return true
                          return t(
                            'SELECT_AT_LEAST_ONE_STATUS',
                            'Select at least one status when creation is enabled.'
                          )
                        },
                      }}
                      render={({ field }) => (
                        <OMultiSelect
                          placeholder={t(
                            'SELECT_UNIT_STATUSES',
                            'Select statuses…'
                          )}
                          options={UNIT_PROPOSAL_STATUS_OPTIONS}
                          value={field.value ?? []}
                          onChange={(value) => {
                            setIsDisable(false)
                            field.onChange(value ?? [])
                          }}
                          wrapperClassName='relative z-[60] mb-2 w-full max-w-2xl group'
                        />
                      )}
                    />
                    <ErrorMessage
                      message={errors?.allowedUnitProposalStatuses?.message}
                    />
                  </div>
                ) : null}
                <div className='pl-3 pr-3 h-56 overflow-y-scroll'>
                  <div className='overflow-x-auto  overflow-y-auto relative rounded-lg border'>
                    <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
                      <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
                        <tr>
                          <th scope='col' className='py-3 px-6 '>
                            {t('SUB_ADMIN_MANAGER')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('O_VIEW')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('SUB_ADMIN_ADD_EDIT')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('O_DELETE')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('IMPORT')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('O_ALL')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {permissionJson?.map((item, i) => (
                          <tr
                            key={i}
                            className='bg-white border-b  dark:bg-gray-800 dark:border-gray-700'
                          >
                            <td className='py-2 px-2 border-r '>
                              {capitalize(startCase(item.manager))}
                            </td>
                            <td className='py-2 px-2 border-r '>
                              {item?.shownView && (
                                <input
                                  type='checkbox'
                                  name={item?.manager}
                                  id='view'
                                  checked={item.view}
                                  onChange={onChange}
                                  title={t('O_VIEW')}
                                />
                              )}
                            </td>

                            <td className='py-2 px-2 border-r '>
                              {item?.shownEdit && (
                                <input
                                  type='checkbox'
                                  id='add'
                                  name={item?.manager}
                                  checked={item.add}
                                  onChange={onChange}
                                  title={t('SUB_ADMIN_ADD_EDIT')}
                                />
                              )}
                            </td>
                            <td className='py-2 px-2 border-r '>
                              {item?.shownDelete && (
                                <input
                                  type='checkbox'
                                  name={item?.manager}
                                  id='delete'
                                  checked={item.delete}
                                  onChange={onChange}
                                  title={t('O_DELETE')}
                                />
                              )}
                            </td>
                            <td className='py-2 px-2 border-r '>
                              {item?.shownImport && (
                                <input
                                  type='checkbox'
                                  name={item?.manager}
                                  id='import'
                                  checked={item.import}
                                  onChange={onChange}
                                  title={t('IMPORT')}
                                />
                              )}
                            </td>
                            <td className='py-2 px-2 border-r '>
                              {item?.shownAll && (
                                <input
                                  type='checkbox'
                                  name={item?.manager}
                                  onChange={checkAll}
                                  title={t('O_ALL')}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setEditShowModal(false)}
                >
                  {t('O_BACK')}
                </button>
                <OButton
                  disabled={!isDirty && isDisable}
                  label={<>{t('SAVE')}</>}
                  type='submit'
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default SubEdit
